type VariantOptionInfo = { name: string; value: string };
type VariantInfo = {
  id?: string | number;
  inventory_quantity: number;
  inventoryPolicy?: string;
  selectedOptions?: VariantOptionInfo[];
};
type ProductInfo = { variants: VariantInfo[] };
export type VariantCollection = { products: ProductInfo[] };

function isInStock(v: VariantInfo, minimalStock: number): boolean {
  return v.inventoryPolicy === "CONTINUE" || v.inventory_quantity > minimalStock;
}

/**
 * A mono-variant product still has something to swap for: the same variant,
 * re-shipped identical (defective/damaged item). The variant picker step
 * auto-selects the sole in-stock variant rather than showing an empty select.
 */
export function hasExchangeableVariant(
  collection: VariantCollection,
  minimalStock: number,
): boolean {
  return collection.products.some((p) => p.variants.some((v) => isInStock(v, minimalStock)));
}
